import { Draft } from 'immer';
import { getType } from 'typesafe-actions';

import { AddCreativeAction, applySmartCenterSuccess, initAdaptiveCreativeSuccess } from '../actions';
import { getCroppedMediaSetItem, getMediaSet } from '../helpers';
import { selectAdaptiveCreativeState } from '../selectors';
import { AddCreativeState } from '../typings';

import { getAdaptiveModalPreviewItemsAfterSmartCenter } from './helpers';

export function processAddAdaptiveCreative(draft: Draft<AddCreativeState>, action: AddCreativeAction): void {
    switch (action.type) {
        case getType(initAdaptiveCreativeSuccess): {
            const creativeState = selectAdaptiveCreativeState(draft);
            const { result } = action;

            creativeState.creativeOptions = result.options;
            creativeState.item = result.item;
            creativeState.bundle = result.bundle;

            if (result.presetId !== undefined) {
                creativeState.presetId = result.presetId;
            }

            if (result.isIdea) {
                creativeState.ideaFilesCropped = false;
            }

            if (result.batchId !== undefined) {
                creativeState.id = result.batchId;
            }

            return;
        }

        case getType(applySmartCenterSuccess): {
            const creativeState = selectAdaptiveCreativeState(draft);
            const { response, smartCenters } = action;

            if (creativeState.previewsModalVisible) {
                creativeState.previewItems = getAdaptiveModalPreviewItemsAfterSmartCenter(
                    creativeState,
                    response.items[0],
                    smartCenters[0]
                );

                return;
            }

            if (creativeState.createPressed) {
                creativeState.previewsModalVisible = true;
                creativeState.previewItems = getAdaptiveModalPreviewItemsAfterSmartCenter(
                    creativeState,
                    response.items[0],
                    smartCenters[0]
                );

                return;
            }

            const { editingFileInfo, item } = creativeState;
            if (!editingFileInfo || !item) {
                return;
            }

            const mediaSet = editingFileInfo.mediaSetId;
            item.mediaSets[mediaSet].items[0].items[0] = getCroppedMediaSetItem(
                response.items[0],
                getMediaSet(item.mediaSets, mediaSet).alias,
                editingFileInfo.fileId,
                smartCenters[0]
            );

            creativeState.ideaFilesCropped = true;

            return;
        }

        default:
            return;
    }
}
